<!--
 * @Author: your name
 * @Date: 2020-06-18 15:06:22
 * @LastEditTime: 2020-06-23 11:03:14
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \leXiangH5线下落地页\src\views\H5Code.vue
--> 
<template>
	<!-- h5端登录code -->
	<div class="home">
		<Loading />
	</div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { login } from "@/utils/login.js";

export default {
	name: "H5Code",
	components: {
		Loading
	},
	data() {
		return {};
	},
	created() {
		this.initCode();
	},
	methods: {
		initCode() {
			const href = window.location.href;
			const codeAndStateArr = href.split("?code=");
			const codeAndState = codeAndStateArr[1];
			const codeArr = codeAndState.split("&state=");
			login("", codeArr[0]);
		}
	}
};
</script>
